/**
 * Application-wide query parameter constants
 * Use these constants instead of hardcoded strings for type safety and maintainability
 */
export enum QueryParams {
  /**
   * Query param for triggering support modal on /my-team page
   * Value should be a support topic key from SupportOptions.json (e.g., 'billing_support', 'platform_support')
   */
  SUPPORT_TYPE = 'support_type',
}

export default QueryParams;
